import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class PagesService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  getPages(page: number = 1, perPage: number = 20, search: string = '') {
    const lang = this.languageService.getLanguage();
    let url = `${environment.apiUrl}admin/pages?lang=${lang}&page=${page}&perPage=${perPage}`;
    
    if (search && search.trim() !== '') {
      url += `&q=${encodeURIComponent(search)}`;
    }

    return this.http.get(url);
  }
  
  getPagesAll() {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/pages/all?lang=${lang}`);
  }
  
  createPage(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/create/page?lang=${lang}`, data);
  }

  updatePage(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/update/page?lang=${lang}`, data);
  }

  getGallery(id: number = 0) {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/page/gallery?lang=${lang}&id=${id}`);
  }

  deletePage(id: number = 0){
    return this.http.post(`${environment.apiUrl}admin/delete/page`, { id });
  }

  checkSlug(slug: string, source: string = 'pages') {
    return this.http.get<{ exists: boolean }>(`${environment.apiUrl}admin/check-slug`, {
      params: { slug, source }
    });
  }

  getCategory(type: string){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}${type}?lang=${lang}`);
  }

}
